import React, { useMemo } from 'react';

import classNames from 'classnames';
import { Checkbox, Collapsible } from 'ncoded-component-library';
import { getArrayLength, getUserFullNameOrEmail } from 'utils';
import ChevrondownIcon from 'icons/Chevrondown.icon';
import GroupUsersIcon from 'icons/GroupUsers.icon';
import { DataRoomMember } from 'router/subrouters/DataRoom/models/DataRoomMember';
import { DataRoomMembersAccessGroup } from 'router/subrouters/DataRoom/models/DataRoomRfi';

import './MembersAccessGroupItem.styles.scss';

type MembersAccessGroupItemProps = {
  className?: string;
  group: DataRoomMembersAccessGroup;
  selectedIds: string[];
  onToggleMember: (memberId: string) => void;
  onToggleGroup: (members: DataRoomMember[]) => void;
};

const MembersAccessGroupItem: React.FC<MembersAccessGroupItemProps> = (
  props,
) => {
  const { className, group, selectedIds, onToggleMember, onToggleGroup } =
    props;

  const { name, members } = group || {};

  const classes = classNames('members-access-group-item', className);

  const { allSelected, mixed } = useMemo(() => {
    const memberIds = members.map(({ _id }) => _id);

    const memberIdsCount = getArrayLength(memberIds);
    const selectedCount = getArrayLength(
      memberIds.filter((id) => selectedIds.includes(id)),
    );

    const allSelected = selectedCount === memberIdsCount;

    return {
      allSelected,
      mixed: selectedCount > 0 && !allSelected,
    };
  }, [members, selectedIds]);

  return (
    <Collapsible
      className={classes}
      defaultOpen
      trigger={
        <div className="members-access-group-item__header">
          <div className="members-access-group-item__title">
            <ChevrondownIcon className="members-access-group-item__chevron" />
            <GroupUsersIcon />
            <span>
              {name} <small>({getArrayLength(members)})</small>
            </span>
          </div>

          <div onClick={(e) => e.stopPropagation()}>
            <Checkbox
              checked={allSelected}
              className={classNames({ mixed })}
              onChange={() => onToggleGroup(members)}
            />
          </div>
        </div>
      }
    >
      <div className="members-access-group-item__members">
        {members.map((member) => (
          <Checkbox
            key={member._id}
            label={getUserFullNameOrEmail(member)}
            checked={selectedIds.includes(member._id)}
            onChange={() => onToggleMember(member._id)}
          />
        ))}
      </div>
    </Collapsible>
  );
};

export default MembersAccessGroupItem;
